import { registerLocaleData } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { inject, LOCALE_ID, NgModule, provideAppInitializer } from '@angular/core';
import { ServiceWorkerModule } from '@angular/service-worker';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
} from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
registerLocaleData(localeFr);
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

/* Providers */
import { AccordionModule } from 'ngx-bootstrap/accordion';
import {
  NgxGoogleAnalyticsModule,
  NgxGoogleAnalyticsRouterModule,
} from 'ngx-google-analytics';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { environment } from './../environments/environment';
import { AuthentificationModule } from './authentification/authentification.module';
import { AutologinComponent } from './authentification/autologin/autologin.component';
import { ComponentsModule } from './components/components.module';
import { ConfigurationModule } from './configuration/configuration.module';
import { EaEnvBorderComponent } from './dashboard/components/ea-env-border/ea-env-border.component';
import { SharedModule } from './dashboard/shared/shared.module';
import { EaFormsModule } from './forms/ea-forms.module';
import { PrNumberPipe } from './pipes/ea-number.pipe';
import { EaPipesModule } from './pipes/ea-pipes.module';
import { PwaInstallBannerComponent } from './pwa/install-banner/pwa-install-banner.component';
import { PwaIosInstallSheetComponent } from './pwa/ios-install-sheet/pwa-ios-install-sheet.component';
import { PwaPushPromptComponent } from './pwa/push-prompt/pwa-push-prompt.component';
import { PushService } from './pwa/push.service';
import { PwaInstallService } from './pwa/pwa-install.service';
import { PwaNotificationsService } from './pwa/pwa-notifications.service';
import { PwaUpdateService } from './pwa/pwa-update.service';
import { SW_REGISTRATION_STRATEGY, serviceWorkerEnabled } from './pwa/service-worker.config';
import { TemplateModule } from './template/template.module';

/* Component */
@NgModule({ declarations: [AppComponent, AutologinComponent, EaEnvBorderComponent,
        PwaInstallBannerComponent, PwaIosInstallSheetComponent, PwaPushPromptComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        FroalaEditorModule.forRoot(),
        FroalaViewModule.forRoot(),
        NgxMaskDirective,
        NgxMaskPipe,
        GoogleMapsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        AppRoutingModule,
        EaPipesModule,
        AccordionModule.forRoot(),
        SharedModule,
        ComponentsModule,
        EaFormsModule,
        TemplateModule,
        HammerModule,
        NgxGoogleAnalyticsModule.forRoot(environment.analytics),
        NgxGoogleAnalyticsRouterModule,
        ConfigurationModule.forRoot(),
        AuthentificationModule.forRoot(),
        // sw-albr.js enveloppe ngsw-worker.js (importScripts) et ajoute la
        // gestion du badge d'icône à la réception d'un push.
        ServiceWorkerModule.register('sw-albr.js', {
            enabled: serviceWorkerEnabled(environment.target),
            registrationStrategy: SW_REGISTRATION_STRATEGY,
        })], providers: [
        provideAppInitializer(() => {
            // Toute l'UX PWA (mise à jour, hors-ligne, invite d'installation Android
            // et iOS) n'est active que sur les cibles où le SW est activé
            // (cf. PWA_ENABLED_TARGETS) — intégration uniquement pour l'instant.
            if (!serviceWorkerEnabled(environment.target)) {
                return;
            }
            inject(PwaUpdateService).init();
            inject(PwaInstallService).init();
            inject(PwaNotificationsService).init();
            inject(PushService).initBadgeClearing();
        }),
        {
            provide: LOCALE_ID,
            useValue: 'fr-FR',
        },
        UntypedFormBuilder,
        PrNumberPipe,
        provideNgxMask(),
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
